import cx from 'classnames';
import styles from './ProductComparisonCard.module.scss';
import { HOSE_WARNING } from '../../../../../constants/commonConstants';

export const renderSpecification = attribute =>
  attribute?.name && attribute.name !== HOSE_WARNING ? (
    <div
      key={`${attribute.name}-${attribute.value}`}
      data-testid="renderSpecification-test"
    >
      <p className="text-sans-serif color-dark-gray text-sm fw-bold mb-0">
        {attribute.name}
      </p>
      <p
        className={cx(
          'text-sans-serif color-dark-gray text-sm mb-1',
          styles['product-card__attribute_value']
        )}
      >
        {attribute.value}
      </p>
    </div>
  ) : (
    <></>
  );

export const getSpecifications = (shortDescription, attributes) => {
  if (attributes && attributes.length > 0) {
    if (shortDescription) {
      return attributes
        .slice(0, 6)
        .map(attribute => renderSpecification(attribute));
    } else {
      return attributes
        .slice(1, 6)
        .map(attribute => renderSpecification(attribute));
    }
  } else {
    return <></>;
  }
};
